import { Button,Form, Input, Alert,message} from "antd";
import { useEffect, useState,useRef, useCallback } from "react";
import apiCalls from "src/api/apiCalls";
import { connect } from 'react-redux';
import Loader from "../shared/loader.component";

const PushConfig =()=>{
   const [errorMessage, setErrorMessage] = useState(null);
   const [webHookUrl,setWebHookUrl]=useState('')
   const [loader,setLoader]=useState()
   const [form] = Form.useForm();
   const shouldLog = useRef(true);

   useEffect(()=>{
    form.resetFields();setErrorMessage(null)
    if(shouldLog.current){
      shouldLog.current = false;generateUrl()}
   },[])
   const generateUrl=async()=>{
    try {
      setLoader(true)
      const response = await apiCalls.getwebHookUrl();
      if (response.ok) {
        setWebHookUrl(response.data?.webHookUrl);
        form.setFieldsValue({ webHookUrl: response.data?.webHookUrl || '' });
        setErrorMessage(null);setLoader(false)
      } else {
        setErrorMessage(apiCalls.isErrorDispaly(response));setLoader(false)
      }
    } catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error));setLoader(false)
    }
   }
  const saveConfig = useCallback(async(values) => {
    setErrorMessage(null);
    let response = await apiCalls.savedevConfig(values);
    if (response.ok) {
      generateUrl()
        message.destroy();
        message.success({
            content: `Config saved successfully`,
            className: 'custom-msg',
            duration: 4
        });
        setErrorMessage(null);
    } else {
        setErrorMessage(apiCalls.isErrorDispaly(response));
    }
  },[])

    const closeErrorMsgHandler=useCallback(()=>{
        setErrorMessage(null)
      },[])

    return(
        <div className=''>
        {errorMessage !== null && (
          <Alert
            className='mb-6'
            type="error"
            description={errorMessage}
            onClose={closeErrorMsgHandler}
            showIcon
            closable
          />
        )}
      {loader?<Loader/>:<div className="border border-StrokeColor p-4 rounded-5 "><h2 className='text-labelGrey text-base font-medium mb-1'>Common Push Address</h2>
        <Form className=""
            initialValues={{webHookUrl}}
                autoComplete="off"
                form={form}
            onFinish={saveConfig}>
        <div className="">
          <div className="">
      <Form.Item
            className='input-style mb-0 flex-1 w-full'
            label=""
            name="webHookUrl"
            rules={[
              {
                required: true,
                message: 'Is Required',
              },
            ]}
          >
            <Input placeholder='Enter Address' />
          </Form.Item>
          </div>
          <div className="mt-5">
            <Button className="primary-btn" htmlType="submit">Save</Button>
            </div>
        </div></Form>
        </div>}
        </div>
    )
}
const connectStateToProps = ({ oidc }) => {
  return {  userDetails: oidc?.user.currentUser}
}
export default connect(connectStateToProps)(PushConfig);